export default __webpack_public_path__ + "static/media/chest0.87f90b95.svg";